import { render } from "./wDelete.vue?vue&type=template&id=946e9fd6&ts=true"
import script from "./wDelete.vue?vue&type=script&lang=ts"
export * from "./wDelete.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__